const getHikeShippingWindow = (now = new Date()) => {
  const clock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  })
  const parts = date => Object.fromEntries(clock.formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]))
  const local = parts(now)
  const civil = new Date(Date.UTC(local.year, local.month - 1, local.day, 13))
  const shipsToday = civil.getUTCDay() !== 0 && local.hour < 13
  if (!shipsToday) civil.setUTCDate(civil.getUTCDate() + 1)
  while (civil.getUTCDay() === 0) civil.setUTCDate(civil.getUTCDate() + 1)
  const wall = civil.getTime()
  let instant = wall
  for (let index = 0; index < 3; index += 1) {
    const observed = parts(new Date(instant))
    instant += wall - Date.UTC(observed.year, observed.month - 1, observed.day, observed.hour, observed.minute, observed.second)
  }
  return { shipsToday, cutoff: new Date(instant), remaining: Math.max(0, Math.ceil((instant - now.getTime()) / 1000)) }
}

;(() => {
  const body = document.body
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  const progressBar = document.querySelector(".fs-hike__rule")
  const progressFill = progressBar?.querySelector("[data-hike-scroll-progress]")
  const shippingTimer = document.querySelector("[data-hike-ship-timer]")
  const shippingLabel = document.querySelector("[data-hike-ship-label]")
  const shippingHours = document.querySelector("[data-hike-ship-hours]")
  const shippingMinutes = document.querySelector("[data-hike-ship-minutes]")
  const shippingSeconds = document.querySelector("[data-hike-ship-seconds]")
  let progressFrame = 0

  const padTime = value => String(value).padStart(2, "0")

  const updateShippingTimer = () => {
    if (!shippingTimer) return
    const { shipsToday, remaining, cutoff } = getHikeShippingWindow(new Date())
    const hours = Math.floor(remaining / 3600)
    const minutes = Math.floor((remaining % 3600) / 60)
    const seconds = remaining % 60
    shippingHours.textContent = padTime(hours)
    shippingMinutes.textContent = padTime(minutes)
    shippingSeconds.textContent = padTime(seconds)
    shippingLabel.textContent = shipsToday ? "Ships today if ordered in" : "Next same-day cutoff"
    shippingTimer.dataset.window = shipsToday ? "today" : "next"
    shippingTimer.setAttribute("aria-label", shipsToday
      ? `${hours} hours and ${minutes} minutes remain before today's 1 PM Central shipping cutoff`
      : `${hours} hours and ${minutes} minutes remain before the next shipping cutoff: ${new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', weekday: 'long', month: 'short', day: 'numeric' }).format(cutoff)} at 1 PM Central`)
  }

  const updateProgress = () => {
    progressFrame = 0
    const scrollRange = document.documentElement.scrollHeight - window.innerHeight
    const progress = scrollRange > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollRange)) : 0
    progressFill?.style.setProperty("width", `${progress * 100}%`)
    progressBar?.setAttribute("aria-valuenow", String(Math.round(progress * 100)))
  }

  const requestProgressUpdate = () => {
    if (progressFrame) return
    progressFrame = window.requestAnimationFrame(updateProgress)
  }

  const openFunnel = () => {
    body.classList.add("fs-hike-funnel-open")
    window.requestAnimationFrame(() => {
      document.querySelector("#dtfs-fs-question")?.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" })
    })
  }

  document.addEventListener("click", event => {
    if (event.target.closest(".fs-hike [data-fs-funnel-cta]")) openFunnel()
  })

  window.addEventListener("scroll", requestProgressUpdate, { passive: true })
  window.addEventListener("resize", requestProgressUpdate)

  if (reducedMotion) {
    document.querySelectorAll(".fs-hike video").forEach(video => video.pause())
  }

  updateProgress()
  updateShippingTimer()
  window.setInterval(updateShippingTimer, 1000)
})()
